<template>
  <b-alert
    :variant="variant"
    :show="show"
    :dismissible="dismissible"
    @dismissed="onDismissed"
    :class="notifClass"
    :fade="fade"
  >
    <template v-if="message.length > 0">
      <v-icon
        v-if="hasIcon"
        v-bind="icon"
      />
      <span class="ml-1"> {{ message }} </span>
    </template>
    <template v-else-if="$slots.default">
      <v-icon
        v-if="hasIcon"
        v-bind="icon"
      />
      <slot name="default"></slot>
    </template>
    <br v-if="refresh" class="d-md-none" />
    <b-link
      v-if="refresh"
      @click="reloadPage"
      href="#"
      class="font-weight-bold float-md-right"
    >
      Reload the page
      <v-icon name="redo" />
    </b-link>
  </b-alert>
</template>
<script>
export default {
  name: 'Notification',
  props: {
    show: {
      type: [Boolean, Number],
      default: false,
    },
    fade: {
      type: Boolean,
      default: false,
    },
    refresh: {
      type: Boolean,
      default: false,
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
    variant: {
      type: String,
      validator(value) {
        return [
          'primary',
          'secondary',
          'success',
          'danger',
          'warning',
          'info',
          'light',
          'dark',
        ].includes(value);
      },
      default: 'primary',
    },
    position: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom'].includes(value),
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasIcon() {
      return !this.$ie(this.icon);
    },
    fixedClass() {
      return `position-fixed fixed-${this.position} m-0 rounded-0`;
    },
    notifClass() {
      return this.isFixed ? this.fixedClass : '';
    },
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    onDismissed() {
      this.$emit('update:show', false);
      this.$emit('dismissed');
    },
  },
};
</script>
